module.exports = __webpack_public_path__ + "img/map2.bd201b10.jpg";